/* unplugin-vue-components disabled */import { render } from "./commonTxt.vue?vue&type=template&id=6462572c"
import script from "./commonTxt.vue?vue&type=script&lang=js"
export * from "./commonTxt.vue?vue&type=script&lang=js"

import "./commonTxt.vue?vue&type=style&index=0&id=6462572c&lang=sass&scope=true"
import "./commonTxt.vue?vue&type=style&index=1&id=6462572c&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__